<div class="streaming-data-section">
  <div class="streaming-data-header">
    <span class="streaming-data-title">UPLOADED STREAMING DATA</span>
  </div>
  <div class="streaming-table-scroll">
    <table class="streaming-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Team Name</th>
          <th>Car #</th>
          <th>Device #</th>
          <th>RTMP URL</th>
          <th>Stream Key</th>
          <th>EIP</th>
          <th>EIP Alloc ID</th>
          <th>Video ID</th>
          <th>HLS Playback URL</th>
          <th>Live</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows(); track row.id) {
          <tr>
            <td>{{ row.id }}</td>
            <td>{{ row.teamName }}</td>
            <td>{{ row.carNumber }}</td>
            <td>{{ row.carDeviceNumber }}</td>
            <td>{{ row.rtmpUrl }}</td>
            <td>{{ row.rtmpStreamKey }}</td>
            <td>{{ row.eip }}</td>
            <td>{{ row.eipAllocationId }}</td>
            <td>{{ row.videoId }}</td>
            <td>{{ row.hlsPlaybackUrl }}</td>
            <td>{{ row.isLive }}</td>
           
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
